/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useRef, useState, useEffect, useCallback } from 'react';

import { Link, useHistory, useParams } from 'react-router-dom';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import * as Yup from 'yup';
import api from '../../../services/api';

import Button from '../../../components/Button';
import {
  Main,
  Section,
  FormCadastroPequenosAlmocos,
  DeleteIcon,
} from './styles';
import { useToast } from '../../../hooks/toast';
import getValidationErrors from '../../../utils/getValidationErrors';
import Input from '../../../components/Input/index';

interface IDeliverymanFormData {
  name: string;
  documentNumber: string;
  licensePlate: string;
  vehicleDocument: string;
  contactNumber: string;
  referenceContactNumber: string;
  additionalData: string;
  username: string;
  password: string;
  job: string;
}

interface IDeliveryParams {
  id: string;
}

// remove tudo que não for dígito, pra comparar telefones sem se importar
// com formatação (espaços, traços, parênteses etc.)
const onlyDigits = (value?: string) => (value || '').replace(/\D/g, '');

const EditarEntregador: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [loading, setLoading] = useState(false);
  const { id } = useParams<IDeliveryParams>();

  const history = useHistory();
  const { addToast } = useToast();

  const [model, setModel] = useState<IDeliverymanFormData>({
    name: '',
    documentNumber: '',
    licensePlate: '',
    vehicleDocument: '',
    contactNumber: '',
    referenceContactNumber: '',
    additionalData: '',
    username: '',
    password: '',
    job: '',
  });

  // id do usuário (control-panel) vinculado a este entregador, encontrado
  // comparando o telefone do entregador com o telefone cadastrado no usuário
  const [linkedUserId, setLinkedUserId] = useState<string | null>(null);

  const [driverOrders, setDriverOrders] = useState<any[]>([]);

  const getDriverOrders = async (deliverymanName: string) => {
    try {
      const today = new Date().toISOString().split("T")[0];

      const response = await api.get(
        `/reports/historic/adminday?start=2026-03-19`
      );

      response.data.data.forEach((order: any) => {
      });

      const orders = response.data.data.filter(
        (order: any) =>
          order.deliverymanName &&
          order.deliverymanName === deliverymanName
      );

      console.log("ENTREGAS DO ENTREGADOR:", orders);
    } catch (error) {
      console.log("Erro ao buscar entregas", error);
    }
  };

  // busca o usuário do control-panel cujo telefone bate com o telefone
  // do entregador, para trazer e-mail (username) e cargo (job) pra tela
  // de edição, e guardar o id pra permitir o update depois
  const findLinkedUser = async (deliverymanContactNumber: string) => {
    try {
      const response = await api.get('/control-panel/list');
      const list = Array.isArray(response.data)
        ? response.data
        : response.data?.data || [];

      const targetPhone = onlyDigits(deliverymanContactNumber);

      const matchedUser = list.find(
        (user: any) => onlyDigits(user.contactNumber) === targetPhone && targetPhone !== '',
      );

      if (matchedUser) {
        setLinkedUserId(matchedUser.id);
        setModel(prev => ({
          ...prev,
          username: matchedUser.username || '',
          job: matchedUser.job || '',
        }));
      } else {
        setLinkedUserId(null);
      }
    } catch (error) {
      console.log('Erro ao buscar usuário vinculado ao entregador', error);
    }
  };

  const next7DaysOrders = driverOrders.filter(order => {
    const deliveryDate = new Date(order.deliveryDate);
    const today = new Date();

    const limit = new Date();
    limit.setDate(today.getDate() + 7);

    return deliveryDate >= today && deliveryDate <= limit;
  });

  useEffect(() => {
    async function loadDeliveryman() {
      const response = await api.get<IDeliverymanFormData>(`deliveryman/read/${id}`);

      setModel(prev => ({ ...prev, ...response.data }));

      getDriverOrders(response.data.name);
      findLinkedUser(response.data.contactNumber);
    }

    loadDeliveryman();
  }, [id]);

  const removeDeliveryman = async () => {
    try {
      setLoading(true);
      const response = await api.delete(`/deliveryman/delete/${id}`);
      setLoading(false);
      addToast({
        type: 'success',
        title: 'Entregador Removido',
        description: 'Entregador removido com sucesso',
      });

      history.push('/entregadores');
    } catch (error: any) {
      setLoading(false);
      addToast({
        type: 'error',
        title: 'Erro na Atualização Entregador',
        description:
          JSON.parse(error.request.response).message ||
          'Falha em atualizar Entregador',
      });
      window.scrollTo(0, 0);
    }
  };

  const handleSubmit = useCallback(
    async (data: IDeliverymanFormData) => {
      try {
        formRef.current?.setErrors({});

        const schema = Yup.object().shape({
          name: Yup.string().required(
            `Campo Obrigatório${window.scrollTo(0, 0)}`,
          ),

          contactNumber: Yup.string().required(
            `Campo Obrigatório${window.scrollTo(0, 0)}`,
          ),

          username: Yup.string().email('Informe um e-mail válido'),

          // campo vazio (senha não alterada) não deve disparar o min(6):
          // transforma '' em undefined antes de validar
          password: Yup.string()
            .transform(value => (!value ? undefined : value))
            .min(6, 'Senha deve ter no mínimo 5 caracteres'),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        const {
          username,
          password,
          job,
          ...deliverymanData
        } = data;

        // se ainda não tem acesso, exige e-mail e senha juntos pra criar
        if (!linkedUserId && (username || password) && !(username && password)) {
          const manualErrors: Record<string, string> = {};
          if (!username) manualErrors.username = 'Preencha o e-mail para criar o acesso';
          if (!password) manualErrors.password = 'Preencha a senha para criar o acesso';

          formRef.current?.setErrors(manualErrors);
          return;
        }

        setLoading(true);

        await api.put(`/deliveryman/update/${id}`, deliverymanData);

        if (linkedUserId) {
          // já tem acesso: só atualiza
          const userPayload: Record<string, string> = {
            name: data.name,
            username,
            job,
            contactNumber: data.contactNumber,
            role: 'DELIVERYMAN',
          };

          // só envia senha se o campo foi preenchido, pra não sobrescrever
          // a senha atual com vazio
          if (password) {
            userPayload.password = password;
          }

          await api.put(`/control-panel/update/${linkedUserId}`, userPayload);
        } else if (username && password) {
          // entregador antigo sem acesso: cria o usuário e vincula de vez
          const userPayload = {
            name: data.name,
            username,
            password,
            job,
            contactNumber: data.contactNumber,
            role: 'DELIVERYMAN',
          };

          const userResponse = await api.post('/control-panel/create', userPayload);
          const createdUserId = userResponse.data.id;

          await api.patch(`/deliveryman/link-user/${id}`, { userId: createdUserId });
          setLinkedUserId(createdUserId);
        }

        window.scrollTo(0, 0);
        addToast({
          type: 'success',
          title: 'Cadastro atualizado!',
          description: 'Cadastro atualizado com sucesso',
        });

        setLoading(false);
        history.push('/entregadores');
      } catch (err: any) {
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const errors = getValidationErrors(err);

          formRef.current?.setErrors(errors);

          return;
        }

        addToast({
          type: 'error',
          title: 'Erro ao atualizar!',
          description: err?.request?.response
            ? JSON.parse(err.request.response).message
            : 'Oops ocorreu um erro ao atualizar o cadastro',
        });
        window.scrollTo(0, 0);
      }
    },
    [addToast, history, id, linkedUserId],
  );

  function handleBack() {
    history.go(-1);
  }

  return (
    <Main>
      <div className="header-main">
        <div>
          <h1>Acompanhe o Cadastro de seus entregadores</h1>
        </div>
        <Link to="/novo-pedido">
          <Button type="button">+ Novo Pedido</Button>
        </Link>
      </div>
      <Section>
        <div className="sectionCard">
          <div className="flex-container">
            <div>
              <div>
                <h2>Editar Cadastro</h2>
              </div>
              <div className="deleteItem">
                <Button
                  type="button"
                  loading={loading}
                  onClick={() => removeDeliveryman()}
                >
                  Remover Entregador
                  <DeleteIcon />
                </Button>
              </div>
            </div>

            <div className="menu-cadastro">
              <Link to="/entregadores">
                <div className="item-novo-cadastro">Cadastrados</div>
              </Link>
              <div className="item-cadastrados">Novo Cadastro</div>
            </div>

            <div>
              <Form ref={formRef} onSubmit={handleSubmit}>
                <FormCadastroPequenosAlmocos>
                  <div className="formulario-cadastro">
                    <div>
                      <div className="form-inputs">
                        <h5>Nome do Entregador*</h5>
                        <Input
                          type="text"
                          name="name"
                          defaultValue={model.name}
                        />
                      </div>
                      <div className="form-inputs">
                        <h5>Documento</h5>
                        <Input
                          type="text"
                          name="documentNumber"
                          defaultValue={model.documentNumber}
                        />
                      </div>
                    </div>
                    <div>
                      <div>
                        <div className="form-inputs">
                          <h5>Placa do Veículo</h5>
                          <Input
                            type="text"
                            name="licensePlate"
                            defaultValue={model.licensePlate}
                          />
                        </div>
                        <div className="form-inputs">
                          <h5>Documento do Veículo</h5>
                          <Input
                            type="text"
                            name="vehicleDocument"
                            defaultValue={model.vehicleDocument}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div className="form-inputs">
                          <h5>Telefone de Contato*</h5>
                          <Input
                            type="text"
                            pattern="^-?[0-9]\d*\.?\d*$"
                            maxLength={10}
                            className="input-contato"
                            name="contactNumber"
                            defaultValue={model.contactNumber}
                          />
                        </div>
                        <div className="form-inputs">
                          <h5>Telefone de Referência</h5>
                          <Input
                            pattern="^-?[0-9]\d*\.?\d*$"
                            maxLength={10}
                            type="text"
                            className="input-contato"
                            name="referenceContactNumber"
                            defaultValue={model.referenceContactNumber}
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <div>
                        <div className="form-inputs">
                          <h5>Informações Adicionais</h5>
                          <Input
                            type="text"
                            className="form-info"
                            name="additionalData"
                            defaultValue={model.additionalData}
                          />
                        </div>
                      </div>
                    </div>

                    {/* ── Acesso ao Sistema ── */}
                    <h4>Acesso ao Sistema</h4>
                    {!linkedUserId && (
                      <p style={{ color: '#c0392b', fontSize: 12 }}>
                        Este entregador ainda não possui usuário de acesso.
                        Preencha e-mail e senha abaixo para criar o login dele.
                      </p>
                    )}
                    <div>
                      <div className="form-inputs">
                        <h5>E-mail (login){!linkedUserId && '*'}</h5>
                        <Input
                          type="text"
                          name="username"
                          defaultValue={model.username}
                        />
                      </div>
                      <div className="form-inputs">
                        <h5>{linkedUserId ? 'Nova Senha' : 'Senha*'}</h5>
                        <Input
                          type="password"
                          name="password"
                          placeholder={
                            linkedUserId
                              ? 'Deixe em branco para manter a atual'
                              : 'Mínimo 5 caracteres'
                          }
                        />
                      </div>
                    </div>
                    <div>
                      <div className="form-inputs">
                        <h5>Cargo</h5>
                        <Input
                          type="text"
                          name="job"
                          defaultValue={model.job}
                        />
                      </div>
                    </div>

                    <h6>*Campos Obrigatórios</h6>
                    <div className="bottomPedidos">
                      <Button loading={loading} type="submit">
                        Salvar
                      </Button>
                      <Button className="allItems" onClick={handleBack}>
                        Voltar
                      </Button>
                    </div>
                  </div>
                </FormCadastroPequenosAlmocos>
              </Form>
            </div>
          </div>
        </div>
      </Section>
    </Main>
  );
};

export default EditarEntregador;
